import Navbar from "pages/Layout/Navbar/Navbar";
import { sidebar } from "pages/Layout/SidebarMenu/sidebar";
import { useSelector } from "react-redux";

import { useEffect, useState } from "react";

import { selectRootAdmin } from "store/reducer/appReducer";
import { authService } from "services/authentication/auth.service";
import { Response } from "interfaces/utils/utils.interface";

export default function Layout() {
  const isRootAdmin = useSelector(selectRootAdmin);
  const [adminMenu, setAdminMenu] = useState<any>();
  
  useEffect(() => {
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // Force root admin to show menu if localStorage indicates root admin
  const forceRootAdmin = localStorage.getItem("cmt_admin") === "1";
  const effectiveIsRootAdmin = isRootAdmin || forceRootAdmin;
  const getProfile = async () => {
    if (!effectiveIsRootAdmin) {
      try {
        await authService.getUserProfile().then(async (resp: Response) => {
          const data = resp.data.data ?? resp.data;
          
          // Check if adminPosition exists
          if (!data.adminPosition) {
            setAdminMenu([]);
            return;
          }
          
          const adminPosition = data.adminPosition;
          const systemUses = adminPosition.adminSystemUses;
          
          // Check if systemUses exists
          if (!systemUses || !Array.isArray(systemUses)) {
            setAdminMenu([]);
            return;
          }
          
          let menu: any = [];
          sidebar.admin.map((item: any) => {
            const adminSystemUses = systemUses.find((sys: any) => item.code === sys.code);
            if (adminSystemUses) {
              menu.push(item);
            }
            return item;
          });
          setAdminMenu(menu);
        });
      } catch (error) {
        console.error('Error getting profile:', error);
        setAdminMenu([]);
      }
    }
  };
  
  return <Navbar listMenu={effectiveIsRootAdmin ? sidebar.root : adminMenu || []} />;
}
